import { RegionInfo } from 'clarifai-web-grpc/proto/clarifai/api/resources_pb';
import { isValidClarifaiUrl } from 'utils/inputs';

export const cropImage = (imgUri: string, callback: (newImg: string) => void, regionInfo?: RegionInfo | null) => {
  const boundingBoxObject = regionInfo?.getBoundingBox()?.toObject();

  if (!boundingBoxObject) {
    callback(imgUri);
    return;
  }

  try {
    const resizeCanvas = document.createElement('canvas');
    const origSrc = new Image();
    origSrc.src = imgUri;
    origSrc.crossOrigin = imgUri && isValidClarifaiUrl(imgUri) ? 'use-credentials' : 'anonymous';
    origSrc.addEventListener('load', () => {
      const ystart = origSrc.height * boundingBoxObject.topRow;
      const xstart = origSrc.width * boundingBoxObject.leftCol;
      const width = (boundingBoxObject.rightCol - boundingBoxObject.leftCol) * origSrc.width;
      const height = (boundingBoxObject.bottomRow - boundingBoxObject.topRow) * origSrc.height;
      resizeCanvas.width = width;
      resizeCanvas.height = height;
      const cnv = resizeCanvas.getContext('2d');
      cnv?.drawImage(origSrc, xstart, ystart, width, height, 0, 0, width, height);
      const newimgUri = resizeCanvas.toDataURL('image/png').toString();
      callback(newimgUri);
    });
  } catch (e) {
    console.warn("Couldn't crop image due to", e);
    callback(imgUri);
  }
};
